import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { DashboardCard } from '../../../../interfaces/strapi';

@Component({
    selector: 'app-jobs-and-careers-carousel-slide',
    templateUrl: './jobs-and-careers-carousel-slide.component.html',
    styleUrls: ['./jobs-and-careers-carousel-slide.component.scss'],
    imports: [NgIf],
})
export class JobsAndCareersCarouselSlideComponent {
  @Input() public slide: DashboardCard | undefined;
}
